import { useUncontrolled } from '@mantine/hooks';

import { Checkbox, CheckboxCardProps as MantineCheckboxCardProps } from '../../../../Inputs';
import { Flex, Stack } from '../../../../Layout';
import { Box } from '../../../../Miscellaneous/Box';
import { cx } from '../../../../Provider/Provider';
import { Text } from '../../../../Typography';
import classes from './CheckboxCard.module.css';

interface CheckboxCardProps extends MantineCheckboxCardProps {
  position?: 'left' | 'right';
  title?: string;
  description: string;
  onChange?: () => void;
  indicator?: React.ReactNode;
  error?: boolean;
}

const CheckboxCard = ({
  className,
  checked,
  defaultChecked,
  onChange,
  position = 'left',
  title,
  description,
  disabled,
  indicator,
  error,
  ...rest
}: CheckboxCardProps) => {
  const [_isChecked, handleChange] = useUncontrolled({
    value: checked,
    defaultValue: defaultChecked,
    finalValue: false,
    onChange,
  });

  return (
    <Checkbox.Card
      className={cx(classes.CheckboxCard, className)}
      onClick={() => handleChange(!_isChecked)}
      checked={_isChecked}
      mod={{
        disabled,
        error,
      }}
      {...rest}
    >
      <Flex className={classes.CheckboxCard__contents} mod={{ position }}>
        {indicator ? <Box flex={1}>{indicator}</Box> : <Checkbox.Indicator disabled={disabled} />}
        <Stack gap={4}>
          {title && <Text className={classes.CheckboxCard__title}>{title}</Text>}
          <Text className={classes.CheckboxCard__description} mod={{ 'has-title': !!title }}>
            {description}
          </Text>
        </Stack>
      </Flex>
    </Checkbox.Card>
  );
};

export { CheckboxCard };
